import React from "react";

import { Card } from "react-bootstrap";

function FounderContact({ contact_text, contact }) {
  return (
    <Card className="border-0 text-center">
      <Card.Body>
        <Card.Text>{contact_text}</Card.Text>
        <address>{contact}</address>
      </Card.Body>
    </Card>
  );
}

export default FounderContact;
